import { take, call, put} from 'redux-saga/effects';
import {
	fetchStatisticsList,
	failFetchStatisticsList,
	setStatisticsList,
	getStatisticsExcel,
	failGetStatisticsExcel,
	successGetStatisticsExcel

} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";

export function* handleFetchStatisticsList() {
	while (true) {
		const action = yield take(`${fetchStatisticsList}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'get-statistics-list/',
			type: 'POST',
			data:action.payload
		});

		if (err || payload.state === 'NG') {
			const msg = String(err).split('Error: ')[1];
			yield put(failFetchStatisticsList({err:msg}));
			continue;
		}
		yield put(setStatisticsList(Object.assign({}, {data:payload}, {})));
	}
}

export function* handleGetStatisticsExcel() {
	while (true) {
		const action = yield take(`${getStatisticsExcel}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'get-statistics-list-excel/',
			type: 'POST',
			data:action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = String(err).split('Error: ')[1];
			yield put(failGetStatisticsExcel({err:msg}));
			continue;
		}
		yield put(successGetStatisticsExcel(Object.assign({}, {data:payload}, {})));
	}
}


// WEBPACK FOOTER //
// ./src/sagas/statistics-list.js